export default __webpack_public_path__ + "static/media/facebook-outline.117459fd.svg";